import { isStreetNameValid } from 'app/validators/validateStreetName';
import { LabelEnum } from 'app/shared/enums';

export default function validateStreetName(value: string) {
  return isStreetNameValid(value) ? undefined : LabelEnum.InvalidStreetName;
}
